module.exports = "/static/fonts/OpenSans-Semibold.woff";